import styled from 'styled-components';

import { BodilFont } from '~src/branding';
import { InputSize } from '~src/model';

export const Label = styled.div<{ size?: InputSize }>(({ size }) => {
  const fontSize = size === 'large' ? 16 : 14;

  return {
    ...BodilFont.style('heading', fontSize),
    fontWeight: 400,
    marginBottom: '4px',
  };
});
